import React, { useContext } from 'react';
import { GqlChannelFragment } from '../apollo/generated/graphql';

export const ChannelContext = React.createContext<GqlChannelFragment>(
  {} as GqlChannelFragment,
);

export function useChannel() {
  return useContext(ChannelContext);
}
